// extracted by mini-css-extract-plugin
export var childrenContainer = "_3u-0";
export var virtualScrollArea = "_3u-1";